// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__Pibfm","Center":"Loader_Center__3M74u"};